export interface HeadlineOverlay {
  enabled: boolean;
  name?: string; // Nome de identificação da headline
  
  // Modo Texto
  headline: {
    text: string;
    /** Tamanho em pixels (10-80). Substituiu o enum 'small'|'medium'|'large'. */
    size: number;
    fontFamily: 'Inter' | 'Arial' | 'sans-serif';
    fontWeight: 'normal' | 'bold' | 'semibold' | 'medium' | 'light';
    color: string;
  };

  subheadline: {
    text: string;
    /** Tamanho em pixels (10-80). Substituiu o enum 'small'|'medium'|'large'. */
    size: number;
    fontFamily: 'Inter' | 'Arial' | 'sans-serif';
    fontWeight: 'normal' | 'bold' | 'semibold' | 'medium' | 'light';
    color: string;
  };
  
  // Modo Texto (controle explícito)
  textMode: {
    enabled: boolean;
  };
  
  // Modo HTML
  htmlMode: {
    enabled: boolean;
    code: string;
  };
  
  // Modo Imagem
  imageMode: {
    enabled: boolean;
    desktopImage?: string; // Imagem para desktop (opcional)
    mobileImage?: string; // Imagem para mobile (opcional)
  };
  
  // Timing
  timing: {
    start: string;        // formato "mm:ss"
    end: string;          // formato "mm:ss" (vazio = até o fim)
    showThroughout?: boolean; // exibir durante todo o vídeo
  };
  
  // Positioning
  position: 'top-left' | 'top-center' | 'top-right' | 'center' | 'bottom-left' | 'bottom-center' | 'bottom-right' | 'top' | 'bottom';
  offsetX?: number;
  offsetY?: number;
  
  // Background
  background: {
    enabled: boolean;
    type: 'solid' | 'gradient' | 'image';
    color: string;
    opacity: number;
    borderRadius?: number;
    padding?: number;
    gradient?: {
      color1: string;
      color2: string;
      direction: 'horizontal' | 'vertical' | 'diagonal';
    };
    imageUrl?: string;
  };
  
  // Animations
  animation: {
    enabled: boolean;
    type: 'fade' | 'slide-up' | 'slide-down' | 'bounce' | 'zoom';
    duration: number;
    delay: number;
  };
  
  // A/B Testing
  abTestConfig: {
    enabled: boolean;
    variations: HeadlineOverlayVariation[];
    status: 'active' | 'paused' | 'finished' | 'draft';
    trafficSplit: number;
    startDate?: string;
    endDate?: string;
    headlineTestId?: string;
  };
}

export interface HeadlineOverlayVariation {
  id: string;
  name: string;
  headline: HeadlineOverlay['headline'];
  subheadline: HeadlineOverlay['subheadline'];
  imageMode?: HeadlineOverlay['imageMode'];
  htmlMode?: HeadlineOverlay['htmlMode'];
  background?: HeadlineOverlay['background'];
  metrics: {
    views: number;
    uniqueViews: number;
    plays: number;
    uniquePlays: number;
    playRate: number;
    engagement: number;
    pitchRetention: number;
    clicks: number;
    ctr: number;
    avgDisplayTime: number;
    conversions: number;
    conversionRate: number;
    revenue: number;
    platform: string;
  };
}

export const defaultHeadlineOverlay: HeadlineOverlay = {
  enabled: false,
  name: '',
  headline: {
    text: '',
    size: 24,
    fontFamily: 'Inter',
    fontWeight: 'normal',
    color: '#000000'
  },
  subheadline: {
    text: '',
    size: 16,
    fontFamily: 'Inter',
    fontWeight: 'normal',
    color: '#555555'
  },
  textMode: {
    enabled: true
  },
  htmlMode: {
    enabled: false,
    code: ''
  },
  imageMode: {
    enabled: false,
    desktopImage: undefined,
    mobileImage: undefined
  },
  timing: {
    start: '',
    end: '',
    showThroughout: true,
  },
  position: 'bottom-center',
  offsetX: 0,
  offsetY: 0,
  background: {
    enabled: true,
    type: 'solid',
    color: 'rgba(0, 0, 0, 0.7)',
    opacity: 0.7,
    borderRadius: 8,
    padding: 16,
    gradient: {
      color1: '#000000',
      color2: '#333333',
      direction: 'horizontal'
    },
    imageUrl: ''
  },
  animation: {
    enabled: true,
    type: 'fade',
    duration: 0.5,
    delay: 0
  },
  abTestConfig: {
    enabled: false,
    variations: [],
    status: 'draft',
    trafficSplit: 50,
    startDate: undefined,
    endDate: undefined
  }
};